import { html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import type { MdcTextField } from '@/components/TextField/TextField'
import type { TextFieldArgs } from '@/components/TextField/types'
import { safeCustomElement } from '@/utilities/custom-element'

@safeCustomElement('mdc-date-picker')
export class MdcDatePicker extends LitElement {
  @property({ type: String }) id = 'datepicker'
  @property({ type: String }) label = ''
  @property({ type: String }) placeholder = ''
  @property({ type: String }) hint = ''
  @property({ type: Boolean }) disabled = false
  @property({ type: Object }) validation: TextFieldArgs['validation'] = undefined
  @property({ type: String }) value = ''
  @property({ type: String }) name = ''
  @property({ type: Boolean }) required = false
  @property({ type: String }) layout = 'floating-label'

  async firstUpdated() {
    const textField = this.shadowRoot?.querySelector('mdc-text-field') as MdcTextField | null
    if (textField) await textField.updateComplete
    const icon = textField?.shadowRoot?.querySelector('.mdc-text-field__icon')
    const input = textField?.shadowRoot?.querySelector('input')
    if (icon && input) {
      ;(icon as HTMLElement).style.cursor = 'pointer'
      icon.addEventListener('click', () => input.showPicker())
    }
  }

  render() {
    // DatePicker is essentially a TextField with type="date" and leftIcon="calendar"
    // Pass validation as JSON string if it exists
    const validationStr = this.validation ? JSON.stringify(this.validation) : ''
    return html`
			<mdc-text-field
				id=${this.id}
				type="date"
				label=${this.label}
				placeholder=${this.placeholder}
				hint=${this.hint}
				?disabled=${this.disabled}
				?required=${this.required}
				validation=${validationStr}
				value=${this.value}
				name=${this.name}
				layout=${this.layout}
				left-icon="calendar"
			></mdc-text-field>
		`
  }
}
